

import React, { createContext, useContext, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { profileData } from "../store/reducers/userSlice";
import { API_GET_PROFILE } from "api/profile";
const ProfileContext = createContext();

export const ProfileCTX = ({ children }) => {
  const [profileData, setProfileData] = useState();
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      const newData = await API_GET_PROFILE();
      console.log("profile", newData);
      setProfileData(newData?.data?.data);
      dispatch(profileData(newData?.data?.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ProfileContext.Provider value={{ profileData,setProfileData }}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileCTX = () => useContext(ProfileContext);
